import '../sass/main.scss';

import '../fonts/LibreBaskerville-Regular.woff2';
import '../fonts/LibreBaskerville-Bold.woff2';
import '../fonts/OpenSans-Regular.woff2';
import '../fonts/OpenSans-SemiBold.woff2';
import '../fonts/OpenSans-Bold.woff2';

import '../img/background-3840.jpg';
import '../img/background-1920.jpg';
import '../img/background-960.jpg';
import '../img/logo.svg';
import '../img/background-icon.svg';

import './layouts/video-modal.js';

import { initModals } from './common/modals.js';

(() => {
    const $content = document.querySelector('.content');
    const $background = document.querySelector('.background');

    if ($content) {
        $content.classList.add('content--loaded');
    }

    if ($background) {
        $background.classList.add('background--loaded');
    }

    initModals();
})();
